import styled from "styled-components";

const PostItContainer = styled.div<{ background: string }>`
  display: inline-block;
  min-height: 40px;
  width: calc(100% - 8px);
  margin-right: 4px;
  margin-bottom: 8px;
  position: relative;
  box-shadow: -1px 1px 1px -1px rgb(0 0 0 / 40%);
  background-image: linear-gradient(225deg, transparent 11px, ${(props) => props.background ?? "none" } 11px);
  word-break: break-word;
  font-size: 0.8rem;

  &:before {
    content: "";
    position: absolute;
    display: block;
    width: 0;
    top: 0;
    right: 0;
    border-width: 0 16px 16px 0;
    border-style: solid;
    border-color: transparent transparent rgba(0, 0, 0, .1) rgba(0, 0, 0, .1);
    box-shadow: -1px 1px 1px -1px rgb(0 0 0 / 40%);
  }

  .options-postIt-canvas{
        display: none;
        flex-wrap: wrap;
        position: absolute;
        top: -16px;
        right: 4px;
        z-index: 1;
        word-break: initial;

        button{
            background-color: ${(props) => props.background };
            border: 1px solid white;
        }

        span._component_tooltip-span{
            background-color: ${(props) => props.background };
            border: 1px solid white;
        }
    }

    textarea { 
        min-height: 85px;
        resize: vertical; 
        background: #fff;
    } 

    
    &:hover{
        .options-postIt-canvas{
            display: flex;
        }
    }
`;


export default PostItContainer;
